import { Pipe, PipeTransform } from '@angular/core';


@Pipe({
    name: 'base64src',
    standalone: true,
})
export class Base64srcPipe implements PipeTransform {
    public transform(data: string, ...args: [string]): string {
        return `data:image/${args[0] || ''};base64,${data}`;
    }
}
